import React from "react";
import {useTranslation} from "react-i18next";
import {UiInputPassword} from "../../../ui-components/inputPassword/UiInputPassword";
import {LoginErrors} from "../login";


type LoginFormType = {
    login: string,
    errors: LoginErrors,
    setPassword: (password: string) => void,
    backToEnterLogin: () => void,
    onSubmit: (event: React.FormEvent<HTMLInputElement>) => void,
}

export const LoginForm: React.FC<LoginFormType> = (props) => {
    const { t } = useTranslation()
    
    return (
        <>
            <div className="flex flex-col gap-12">
                <div>
                    <p className="text-3xl text-center mb-2">{}</p>
                </div>
                
                <div>
                    <div>
                        <UiInputPassword
                            placeholder={t("form.password")}
                            onChange={(event) => {
                                props.setPassword((event.target as HTMLInputElement).value)
                            }}
                            isOnError={props.errors.passwordIsOnError}
                            onSubmit={props.onSubmit}                            
                        />

                        {props.errors.passwordIsOnError &&
                            <p className="text-danger">{props.errors.passwordErrorMessage}</p>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
